module.exports = __webpack_public_path__ + "img/book.3993d175.png";